import { render, staticRenderFns } from "./SlAreaCascader.vue?vue&type=template&id=5b185fca&scoped=true&"
import script from "./SlAreaCascader.vue?vue&type=script&lang=js&"
export * from "./SlAreaCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b185fca",
  null
  
)

export default component.exports